import { UseQueryOptions, UseQueryResult, useQuery } from 'react-query';
import { captureException } from '@sentry/react';
import { ViewMeters } from '@enmon/commons/lib/enmon';
import { useIntl } from 'react-intl';
import { useServices } from '../../../../services/useServices';
import { QUERY_KEYS } from '../../../../utils/queryKeys';
import { GetMetersArg, GetMetersResult } from '../../../../services/api/enmonTools';
import { useAppMessages } from '../../../useAppMessages';
import { Meters as messages } from '../../../messages';

export const useEnmonMeters = <TView extends ViewMeters = ViewMeters.Default>(
  filter: GetMetersArg['filter'] = {},
  { enabled, staleTime, onSuccess }: UseQueryOptions<GetMetersResult<TView>> = {},
  view: TView = ViewMeters.Default as TView,
): UseQueryResult<GetMetersResult<TView>> => {
  const intl = useIntl();
  const {
    enmonTools: {
      meters: { find },
    },
  } = useServices();

  const appMessages = useAppMessages();

  return useQuery({
    queryKey: QUERY_KEYS.enmonTools.meters.filter({ ...filter, view }),
    queryFn: async ({ signal }) => await find({ filter, view, signal }),
    enabled,
    staleTime,
    onError: error => {
      console.error(error);
      captureException(error);
      appMessages.error(intl.formatMessage(messages.noMetersFound));
    },
    onSuccess,
  });
};
